module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"hasNoReferences":"No system references found"},"no":{"hasNoReferences":"Fant ingen systemreferanser"}}')
  delete Component.options._Ctor
}
